import MarkerClusterer from '../googlemapscluster';
import * as m2 from '../../images/markers/m2.png';
import * as m1 from '../../images/markers/m1.png';

export default {
    init() {

        let branches = jQuery("#branches");

        if (branches.length)
        {
            setTimeout(() => {
                $('body,html').animate({
                    scrollTop: $("#branches").offset().top - 150
                }, 2000);  
            }, 300);
        }
      

        let markers = [];
        let categoriesSelected = [];
        let markerCluster;
        let bounds = new google.maps.LatLngBounds();
        /*let map = new google.maps.Map(document.getElementById('map'), {
            zoom: 8,
            center: {lat: -27, lng: 134},
            disableDefaultUI: true,
        });*/
        
        function initMap() 
        {
            
            
            var protocol = window.location.protocol.replace(/:/g,'');
            var domain = window.location.hostname;
            var port = window.location.port;

            jQuery.ajax({
                type : "post",
                dataType : "json",
                url : ajax_object.ajax_url,
                data : {action: "get_branch_posts"},
                success: function(response) {
                    if (!response)
                    {
                        return;
                    }
    
                    if (!response.data)
                    {
                        return;
                    }
    
                    let locations = response.data;

                    markers = locations.map(function(location, i) {
                        bounds.extend(new google.maps.LatLng(location.location));
                        map.fitBounds(bounds);
                        return new google.maps.Marker({
                            position: location.location,
                            icon: m2,
                            categories: location.features,
                            title: location.title,
                            id: location.id
                        });
                    });

                            
                    markers.forEach(marker => {
                        google.maps.event.addListener(marker,'click',function() 
                        {
                            closeBranches();

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $(`#findUs #${marker.id}`).offset().top - 300
                                
                            }, 1500).promise().done(function(){
                                openBranch(marker.id);
                            });

                            
                        }); 
                    });
            
                    markerCluster = new MarkerClusterer(map, markers,
                        {
                            minZoom: 8,
                            maxZoom: 8,
                            gridSize: 50,
                            ignoreHidden: true,
                            styles: 
                            [
                                {
                                    height: 74,
                                    url: m1,
                                    width: 90,
                                    textColor: "#ffffff",
                                    textSize: 17,
                                    anchorText: [0, 4]
                                }
                            ] 
                        }
              
                    );
                }
             });
    
 
        
            
        }

        //google.maps.event.addDomListener(window, 'load', initMap);


        jQuery("#branchFeatures .feature").click(function() {
            let id = jQuery(this).data('id');

            if (!id)
            {
                return;
            }

            let alreadyAdded = jQuery.inArray( id, categoriesSelected );

            if (alreadyAdded != -1)
            {
                categoriesSelected.splice(alreadyAdded, 1);
                jQuery(this).removeClass("selected");
            } else {
                categoriesSelected.push(id);
                jQuery(this).addClass("selected");
            }
            
            filterMarkers();

        });

        function filterMarkers() 
        {
            let currentCategories = [];
            
            for (let i = 0; i < markers.length; i++) 
            {
                let marker = markers[i];

                let categoryFound = true;

                if (!marker.categories)
                {
                    marker.setVisible(true);
                    continue;
                }

                for (let i=0; i < categoriesSelected.length; i++)
                {
                    let category = categoriesSelected[i];

                    let hasCategory = jQuery.inArray( category, marker.categories );
                    
                    if (hasCategory === -1)
                    {
                        categoryFound = false;
                    }
                }
                
                if (categoryFound == true) 
                {
                    currentCategories.push(marker);
                    marker.setVisible(true);
                }

                else {
                    marker.setVisible(false);
                }
            }

            for (let i=0; i < currentCategories.length; i++)
            {
                let location = currentCategories[i].position;
                bounds.extend(location);
                map.fitBounds(bounds);
            }

            markerCluster.repaint();
        }

        function closeBranches()
        {
            jQuery(`#findUs .branch.clickable`).each(function () { 
                jQuery(this).removeClass("active");
                jQuery(".clp", this).removeClass('fa-angle-up');
                jQuery(".clp", this).addClass('fa-angle-down');
            });
        }

        function openBranch(id) 
        {
            jQuery(`#findUs .branch`).not(`#findUs #${id}`).each(function () { 
                jQuery(this).removeClass("active");
                jQuery(this).removeClass("selected");
                
                if (jQuery(this).hasClass("clickable"))
                {
                    jQuery(".clp", this).removeClass('fa-angle-up');
                    jQuery(".clp", this).addClass('fa-angle-down');
                }

            });
            if (jQuery(`#findUs #${id}`).hasClass("active"))
            {
                jQuery(`#findUs #${id}`).removeClass("active");
                jQuery(`#findUs #${id}`).removeClass("selected");
                jQuery(`#findUs #${id} .clp`).removeClass('fa-angle-up');
                jQuery(`#findUs #${id} .clp`).addClass('fa-angle-down');
                
            } else {
                if (jQuery(`#findUs #${id}`).hasClass("clickable"))
                {
                    jQuery(`#findUs #${id}`).removeClass("selected");
                    jQuery(`#findUs #${id}`).addClass("active");
                } else {
                    jQuery(`#findUs #${id}`).removeClass("selected");
                    jQuery(`#findUs #${id}`).addClass("selected");
                }
                
            }
        }; 

        jQuery( "#findUs .branch" ).click(function(e) {

            let link = jQuery(this).data('url');

            if (link != undefined)
            {
                window.location.href = link;
                return;
            }

            if (e.target.nodeName == "BUTTON" || e.target.nodeName == "A")
                return;

            let id = jQuery(this).data('id');

            jQuery('#findUs .branch.clickable').not(this).each(function () { 
                jQuery(this).removeClass("active");
                jQuery(".clp", this).removeClass('fa-angle-up');
                jQuery(".clp", this).addClass('fa-angle-down');
            });
            
            if (jQuery(this).hasClass("active"))
            {
                jQuery(this).removeClass("active");
                jQuery(".clp", this).removeClass('fa-angle-up');
                jQuery(".clp", this).addClass('fa-angle-down');
                
            } else {
                
                jQuery(this).addClass("active");
                jQuery(".clp", this).removeClass('fa-angle-down');
                jQuery(".clp", this).addClass('fa-angle-up');
            }

        });



 
        
    },
    finalize() {


    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/findUs.js